module.exports = __webpack_public_path__ + "assets/d81f1fd905d165c4616b027a4c1c0d26.png";